// extracted by mini-css-extract-plugin
export var dropdown = "_sl-0";
export var imageWrapper = "_sl-3";
export var itemNameContainer = "_sl-1";
export var productImage = "_sl-2";
export var spinnerWrapper = "_sl-4";